import CIcon from '@coreui/icons-react';
import {
    cilChatBubble,
    cilDescription,
    cilFolderOpen,
    cilLayers,
    cilNotes,
    cilShortText,
    cilTag,
} from '@coreui/icons';
import { CNavLink } from '@coreui/react';
import { INavigation } from '../../types';
import {
    PAGE_CONTACTS,
    PAGE_DOCUMENTS,
    PAGE_ARTICLES,
    PAGE_DRAFTS,
    PAGE_DOCUMENT_TEMPLATES,
    PAGE_KEYWORDS,
    PAGE_DOCUMENT_GROUP_PAGES,
} from '../../PagesNames';
import { Language } from '../../language/English';
import { USER_ROLE_ADMIN } from '../../Constant';

const commonPermissions = [
    Language.DOCUMENT_TEMPLATES,
    Language.CONTACTS,
    Language.ARTICLES,
    Language.DRAFTS,
    Language.DOCUMENTS,
    Language.KEYWORDS,
    Language.DOCUMENT_GROUP_PAGES,
];

export const NavigationPermissions: any = {
    [USER_ROLE_ADMIN]: [...commonPermissions],
};

export const Navigation: INavigation[] = [
    {
        component: CNavLink,
        name: Language.DOCUMENT_TEMPLATES,
        to: PAGE_DOCUMENT_TEMPLATES,
        icon: <CIcon icon={cilFolderOpen} customClassName="nav-icon" />,
    },
    {
        component: CNavLink,
        name: Language.DRAFTS,
        to: PAGE_DRAFTS,
        icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
    },
    {
        component: CNavLink,
        name: Language.DOCUMENTS,
        to: PAGE_DOCUMENTS,
        icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
    },
    {
        component: CNavLink,
        name: Language.DOCUMENT_GROUP_PAGES,
        to: PAGE_DOCUMENT_GROUP_PAGES,
        icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
    },
    {
        component: CNavLink,
        name: Language.KEYWORDS,
        to: PAGE_KEYWORDS,
        icon: <CIcon icon={cilTag} customClassName="nav-icon" />,
    },
    {
        component: CNavLink,
        name: Language.ARTICLES,
        to: PAGE_ARTICLES,
        icon: <CIcon icon={cilShortText} customClassName="nav-icon" />,
    },
    {
        component: CNavLink,
        name: Language.CONTACTS,
        to: PAGE_CONTACTS,
        icon: <CIcon icon={cilChatBubble} customClassName="nav-icon" />,
    },
];
